import React from "react";
import { CircularProgress, Typography, Box } from "@mui/material";

const Loading = ({ text = "Loading...", size=28 }) => {
  return (
    <Box className="flex items-center justify-center p-6 w-full gap-4">
      <CircularProgress color="primary" size={size} />
      {text && (
        <Typography
          variant="body2"
          className="text-gray-600 font-medium"
        >
          {text}
        </Typography>
      )}
    </Box>
  );
};

export default Loading;
